/* Protection Knowledge Center — rail controls + filter pills.
   Progressive enhancement only: everything stays usable with JS disabled
   (the rails are native overflow scrollers). */

if (!customElements.get('pkc-rail')) {
  class PkcRail extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-pkc-rail]');
      this.prev = this.querySelector('[data-pkc-prev]');
      this.next = this.querySelector('[data-pkc-next]');
      if (!this.rail) return;

      this.onScroll = this.update.bind(this);
      this.rail.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });

      if (this.prev) this.prev.addEventListener('click', () => this.scrollBy(-1));
      if (this.next) this.next.addEventListener('click', () => this.scrollBy(1));

      this.update();
    }

    disconnectedCallback() {
      if (this.rail) this.rail.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    step() {
      const card = this.rail.firstElementChild;
      if (!card) return this.rail.clientWidth;
      const gap = parseFloat(getComputedStyle(this.rail).columnGap || '0') || 0;
      return Math.round(card.getBoundingClientRect().width + gap);
    }

    scrollBy(direction) {
      const page = Math.max(this.step(), Math.round(this.rail.clientWidth * 0.8));
      this.rail.scrollBy({ left: direction * page, behavior: 'smooth' });
    }

    update() {
      const max = this.rail.scrollWidth - this.rail.clientWidth - 1;
      const overflowing = max > 0;
      // The prev arrow only exists once you've scrolled. The next arrow stays put
      // when the rail doesn't overflow, so the band matches the approved design.
      if (this.prev) this.prev.hidden = !overflowing || this.rail.scrollLeft <= 0;
      if (this.next) this.next.hidden = !overflowing || this.rail.scrollLeft >= max;
    }
  }

  customElements.define('pkc-rail', PkcRail);
}

/* Filter pills: client-side filtering by category handle. Pills that point at
   a URL are left alone so merchants can link to collections/pages instead. */
if (!customElements.get('pkc-filters')) {
  class PkcFilters extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('[data-pkc-filter]'));
      this.scope = document.getElementById(this.dataset.target || '');
      if (!this.buttons.length || !this.scope) return;
      this.items = Array.from(this.scope.querySelectorAll('[data-pkc-tags]'));
      this.buttons.forEach((btn) => btn.addEventListener('click', () => this.apply(btn)));
    }

    apply(btn) {
      const value = (btn.dataset.pkcFilter || '').trim().toLowerCase();
      this.buttons.forEach((b) => {
        const isActive = b === btn;
        b.setAttribute('aria-pressed', String(isActive));
        b.classList.toggle('pkc-pill--active', isActive);
        b.classList.toggle('is-active', isActive);
      });
      this.items.forEach((item) => {
        const tags = (item.dataset.pkcTags || '').toLowerCase();
        const show = !value || value === 'all' || tags.split(',').map((t) => t.trim()).includes(value);
        if (show) {
          item.removeAttribute('hidden');
          item.style.removeProperty('display');
        } else {
          item.setAttribute('hidden', '');
          item.style.setProperty('display', 'none', 'important');
        }
      });
      this.scope.scrollTo({ left: 0, behavior: 'smooth' });
      const rail = this.scope.closest('pkc-rail');
      if (rail && typeof rail.update === 'function') {
        rail.update();
      }
    }
  }

  customElements.define('pkc-filters', PkcFilters);
}
